module.exports = __webpack_public_path__ + "images/fc8adaa2.inviteIcon_block.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/inviteCodePage/images/inviteIcon_block.webp
// module id = RskK
// module chunks = 0